module.exports = __webpack_public_path__ + "static/media/hrRound.f656b649.svg";